import { useCallback, useMemo } from 'react';
import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
export function useWorkspaceVisibility(param) {
    let { workspaces } = param;
    const { api, setWorkspaces, fetchUserInfo } = useStoreActions();
    const { t } = useLocaleKeys('components.navigation.businessSwitcher');
    const { mutate } = useMutationState({
        mutationFn: (param)=>{
            let { businessId, visibility } = param;
            return api.user.setWorkspaceVisibility(businessId, visibility);
        },
        onError: ()=>{
            fetchUserInfo();
        },
        toasts: {
            errorMessage: t.hideError()
        }
    });
    const setVisibility = useCallback((businessId, visibility)=>{
        setWorkspaces(workspaces.map((workspace)=>workspace.id() === businessId ? workspace.setVisibility(visibility) : workspace));
        mutate({
            businessId,
            visibility
        });
    }, [
        workspaces,
        setWorkspaces,
        mutate
    ]);
    return useMemo(()=>({
            setVisibility
        }), [
        setVisibility
    ]);
}
